import React, { useEffect } from 'react'

export default function Open() {
    useEffect(() => {
        const userAgent = navigator.userAgent || window.opera

        const params = new URLSearchParams(window.location.search)
        const path = params.get('path')
        const appDeepLink = path
            ? `firstdance://${path}`
            : 'firstdance://';
        console.log("App Deep Link", appDeepLink)

        const androidStoreLink = 'https://play.google.com/store/apps/details?id=com.firstdance.firstdance'
        const iosStoreLink = 'https://apps.apple.com/uk/app/first-dance/id6739738754'
        const fallback = 'https://firstdance.app'

        const delayRedirect = setTimeout(() => {
            window.location.href = appDeepLink
        }, 500)

        const timeout = setTimeout(() => {
            if (/android/i.test(userAgent)) {
                window.location.href = androidStoreLink
            } else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
                window.location.href = iosStoreLink
            } else {
                window.location.href = fallback
            }
        }, 2500)

        return () => {
            clearTimeout(delayRedirect)
            clearTimeout(timeout)
        }
    }, [])

    return (
        <div style={{ minHeight: '60vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}>
            <div style={{ maxWidth: 600, textAlign: 'center' }}>
                <h1 style={{ margin: 0, color: '#454C5C' }}>Opening First Dance…</h1>
                <p style={{ color: '#666' }}>If nothing happens, we’ll redirect you to the app store shortly.</p>
            </div>
        </div>
    )
}


